import type { PayloadAction } from "@reduxjs/toolkit";
import { Operation } from "Data/Objects/Event";
import { createAppSlice } from "Data/Redux/Store";
import type { AlarmEventState } from "Interfaces";

const initialState: AlarmEventState = {
	name: "SENSOR1",
	operation: Operation.NORMALLY_OPEN,
	alarmOut: false,
	snapshot: false,
	whiteLight: true,
	redBlueLight: true,
	audioAlarm: true,
	recording: false,
	email: false,
	ftp: false
};

export const setAlarmEventReducer = (state: AlarmEventState, action: PayloadAction<AlarmEventState>) => {
	return action.payload;
};

export const getAlarmEvent = (state: AlarmEventState) => {
	return state;
};

const alarmEventSlice = createAppSlice({
	name: "alarmEvent",
	initialState,
	reducers: {
		setAlarmEventAction: setAlarmEventReducer
	},
	selectors: {
		selectAlarmEvent: getAlarmEvent
	}
});

export default alarmEventSlice;

export const { setAlarmEventAction } = alarmEventSlice.actions;
export const { selectAlarmEvent } = alarmEventSlice.selectors;
